import axios from 'axios'

export const configuration = {
  namespaced: true,
  state: {
    isLoading: false,
    loaded: false,
    config: null
  },
  getters: {
    ConfigIsLoading: state => state.isLoading,
    ConfigIsLoaded: state => state.loaded,
    Config: state => state.config
  },
  mutations: {
    loadingConfigStarted (state) {
      state.loaded = false
      state.isLoading = true
    },
    ConfigUpdated (state, payload) {
      state.config = payload.config
      state.loaded = true
      state.isLoading = false
    }
  },
  actions: {
    ConfigRequirement (context) {
      return new Promise(
        (resolve) => {
          context.commit('loadingConfigStarted')
          return axios.post(context.rootState.vaconfig.ServerURL + 'configuration/get/')
            .then((response) => {
              context.commit('ConfigUpdated', {config: response.data})
              resolve()
            })
            .catch((reason) => {
              throw String('Loading config: ' + reason)
            })
        }
      )
    },
    ChangeConfig (context, newConfig) {
      context.commit('ConfigUpdated', {config: newConfig})
    }
  }
}

export default {
  configuration
}



// WEBPACK FOOTER //
// ./src/store/configuration.js